import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { companyInfo } from '../mock';

export const Contact = () => {
  return (
    <section id="contact" className="py-16 md:py-24 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
            Contact Us
          </h2>
          <div className="w-24 h-1 bg-blue-500 mx-auto mb-6"></div>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Get in touch with us for any inquiries about our vulcanizing machines and services
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-slate-800 p-6 rounded-lg text-center hover:bg-slate-700 transition-colors duration-300">
            <div className="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail size={28} />
            </div>
            <h3 className="text-lg font-semibold mb-2">Email</h3>
            <a
              href={`mailto:${companyInfo.email}`}
              className="text-gray-300 hover:text-blue-400 transition-colors duration-200 break-words block px-2">

              {companyInfo.email}
            </a>
          </div>

          <div className="bg-slate-800 p-6 rounded-lg text-center hover:bg-slate-700 transition-colors duration-300">
            <div className="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Phone size={28} />
            </div>
            <h3 className="text-lg font-semibold mb-2">Phone</h3>
            <a
              href={`tel:${companyInfo.phone}`}
              className="text-gray-300 hover:text-blue-400 transition-colors duration-200">

              {companyInfo.phone}
            </a>
          </div>

          <div className="bg-slate-800 p-6 rounded-lg text-center hover:bg-slate-700 transition-colors duration-300">
            <div className="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <MapPin size={28} />
            </div>
            <h3 className="text-lg font-semibold mb-2">Address</h3>
            <p className="text-gray-300">Work: Tek Solutions & Consultants,M-15 & M-17, Industrial Estate, Yantrapur, HARIHAR-577601,Karnataka, India
Office: TF-311 Harsha Residency,Silver Park, Devangpet Road, Hubballi-580023
            </p>
          </div>

          <div className="bg-slate-800 p-6 rounded-lg text-center hover:bg-slate-700 transition-colors duration-300">
            <div className="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Clock size={28} />
            </div>
            <h3 className="text-lg font-semibold mb-2">Business Hours</h3>
            <p className="text-gray-300">
              Mon - Sat<br />9:00 AM - 6:00 PM
            </p>
          </div>
        </div>
      </div>
    </section>);

};